module.exports = __webpack_public_path__ + "static/media/hwaitCheck.48925ea4.svg";